import { render, staticRenderFns } from "./Editions.vue?vue&type=template&id=d89bc1f8&scoped=true"
import script from "./Editions.vue?vue&type=script&lang=js"
export * from "./Editions.vue?vue&type=script&lang=js"
import style0 from "./Editions.vue?vue&type=style&index=0&id=d89bc1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89bc1f8",
  null
  
)

export default component.exports